/**
 * @graph-stack spec-console
 * @graph-domain Infrastructure
 * @graph-business i18next 初期化。日本語 / 英語 / ベトナム語の翻訳リソースをロードしブラウザ言語検出で自動切替する。
 * @graph-connects none
 */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { enMessages } from './locales/en/index.js';
import { jaMessages } from './locales/ja/index.js';
import { viMessages } from './locales/vi/index.js';

/** @graph-connects none */
export const defaultNS = 'common';
/**
 * 画面の文言。仕様グラフが本文を揃える言語（`SPEC_LOCALES`）と同じ 3 言語を持つ。
 *
 * 本文だけ 3 言語で画面の枠が 2 言語だと、切り替えた読み手には「本文は読めるが見出しが
 * 読めない」画面が出る。揃える言語が増えたときにここを足し忘れると `spec-locale.ts` の
 * `SPEC_LOCALE_ENDONYMS` が型エラーになり、機械が気づく。
 *
 * 文言は機能ごとの JSON（`locales/<言語>/*.json`）に割ってあり、言語ごとの束ね口
 * （`locales/<言語>/index.ts`）が 1 つの namespace（`common`）へ合成する。キーの参照
 * （`t('overview.laneEpic')` など）は割る前と 1 文字も変わらない。
 * @graph-connects none
 */
export const resources = {
  ja: {
    common: jaMessages,
  },
  en: {
    common: enMessages,
  },
  vi: {
    common: viMessages,
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });
